// extracted by mini-css-extract-plugin
export var productImage = "_je-1";
export var viewLink = "_je-2";
export var wishlistItem = "_je-0";